<div class="pmbonus-modal-shadow"></div>
<div class="pmbonus">
  <div class="pmbonus__header">
    <div class="pmangbouns__header__title">피망보너스 혜택 받기</div>
    <a data-pmbonus-click="close" href="#" class="pmbonus__header__btn-x"></a>
  </div>
  <div class="pmbonus__wrap">
    <div data-pmbonus-tab class="pmbonus__tab pmbonus-tab-benefit">
      <a data-pmbonus-switch-tab="benefit" href="#" class="pmbonus__tab__btn-benefit">혜택받기</a>
      <a data-pmbonus-switch-tab="usage" href="#" class="pmbonus__tab__btn-usage">사용내역</a>
    </div>
    <div data-pmbonus-tab class="pmbonus__contents pmbonus-tab-benefit">
      <div class="pmbonus__contents__my-bonus">나의 피망 보너스</div>
      <div class="pmbonus__contents__user-bonus">
        <span><em><strong>{{userName}}</strong></em>님의 현재 사용 가능한 피망보너스는
          <em><strong>{{totalPoint}}점</strong></em>
          입니다.</span>
      </div>
      <div class="pmbonus__contents__notice">
        ※ 유효기간은 <em><u>보너스가 적립된 다음달로부터 4개월</u></em>까지며, 현재 <em>{{startMonth}}</em>부터 적립된 보너스를 사용하실 수 있습니다.
      </div>
      <div class="pmbonus__contents__benefit" cellspacing="0">

        <table class="pmbonus__benefit-tbl">
          <caption>혜택 받기</caption>
          <tbody>
            <tr class="pmbonus__usage__table-head">
              <th class="col1">피망보너스</th>
              <th class="col2">혜택</th>
              <th class="col3">선택</th>
            </tr>
            {{#rewards}}
            <tr class="{{#onlyMoney}}pmbonus__money{{/onlyMoney}}{{^onlyMoney}}pmbonus__effect{{/onlyMoney}} pmbonus__status--{{status}}">
              <td class="col1">
                <em><strong>{{pointText}}점</strong></em>
              </td>
              <td class="col2">
                {{#onlyMoney}}
                <span class="icon-pmang-gold"></span>
                <span>{{reward}} 골드</span>
                {{/onlyMoney}}
                {{^onlyMoney}}
                <span class="pmbonus__reward-text">{{reward}}</span>
                <span class="pmbonus__reward-date">{{periodWarning}}</span>
                {{/onlyMoney}}
              </td>
              <td class="col3">
                <!-- .checked | .disabled -->
                <label class="pmbonus__radio-button {{status}}" data-pmbonus-reward-id="{{id}}">
                  <span class="pmbonus__radio-checked"></span>
                </label>
              </td>
            </tr>
            {{/rewards}}
          </tbody>
        </table>

        <div class="pmbonus__benefit__check-message">
          <strong>선택하신 혜택을 받으시겠습니까?</strong>
        </div>
        <div class="pmbonus__buttons">
          <a href="#" data-pmbonus-click="getReward" class="btn-confirm">받기</a>
          <a href="#" data-pmbonus-click="close" class="btn-cancel">취소</a>
        </div>
      </div>

      <div class="pmbonus__contents__usage">
        <table class="pmbonus__history-tbl">
          <caption>
            사용내역
          </caption>
          <tr class="pmbonus__usage__table-head">
            <th>월</th>
            <th>적립 보너스</th>
            <th>차감 보너스</th>
          </tr>
          {{#history}}
          <tr>
            <td>
              <b>{{regDate}}</b>
            </td>
            <td>
              <b>{{saved}}점</b>
            </td>
            <td>
              <b>{{consumed}}점</b>
            </td>
          </tr>
          {{/history}}
          <tr>
            <td>
              <strong><em>현재 사용 가능한 피망 보너스</em></strong>
            </td>
            <td colspan="2">
              <strong class="pmbonus__total"><em>{{totalPoint}}점</em></strong>
            </td>
          </tr>
          <tr>
            <td>
              다음달 유효기간이 만료되는 보너스
            </td>
            <td colspan="2">
              <strong>0점</strong>
            </td>
          </tr>
        </table>

        <div class="pmbonus__buttons">
          <a data-pmbonus-click="close" href="#" class="btn-confirm">확인</a>
        </div>
      </div>
    </div>
  </div>
  <div class="pmbonus-popup-container"></div>
</div>